<template>
  <div id="app">
    <navigation></navigation>
    <InfoPanel></InfoPanel>
    <router-view></router-view>
  </div>
</template>

<script>
import Navigation from './components/Navigation.vue';
import InfoPanel from './components/InfoPanel'
import links_raw from './assets/links.csv'
import nodes_raw from './assets/nodes.csv'


export default {
  components:{
    Navigation,InfoPanel
  },
  created(){
  },
  beforeCreate(){
    this.$store.dispatch("load_base_data",{nodes:nodes_raw,links:links_raw})
  },
  name: 'app',
  data () {
    return {
    }
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue